import type { IconData } from '@stacksjs/iconify-core'

export const dropDownMenu: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\"><path stroke-linejoin=\"round\" d=\"M3.372 32.307c.252 2.473 2.261 4.225 4.744 4.352C11.334 36.824 16.528 37 24 37s12.666-.176 15.884-.34c2.483-.128 4.492-1.88 4.743-4.352c.201-1.979.373-4.719.373-8.308c0-3.59-.171-6.33-.372-8.307c-.252-2.473-2.261-4.225-4.744-4.352C36.666 11.176 31.473 11 24 11s-12.666.176-15.884.34c-2.483.128-4.492 1.88-4.744 4.353C3.172 17.67 3 20.41 3 24s.172 6.33.372 8.308Z\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M24 11v26\"/><path stroke-linecap=\"round\" d=\"M30 23s3.267 4 4.5 4s4.5-4 4.5-4\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default dropDownMenu
